import { AgentRoles } from '@/context/user/user.types'

export const initialValues: CereateAgentFormValuesType = {
  adminUserId: undefined,
  managerUserId: undefined,
  role: AgentRoles.AGENT,
  standard: true,
  corporateHousing: false,
}

export interface CereateAgentFormValuesType {
  adminUserId?: number
  corporateHousing: boolean
  managerUserId?: number
  role: AgentRoles
  standard: boolean
}
